import React from 'react';

import { Container, Row, Col } from 'react-bootstrap';


class BookPage extends React.Component  {
  constructor(arg) {
    super(arg);
    this.state = {
      index:arg.defaultIndex,
      arg:arg};
  }

  setIndex(nextIndex) {
    if (this.state.index == nextIndex) return;
    window.scrollTo(0, 0);
    this.setState(state => ({
      index: nextIndex
    }));
  }

  render() {
    var this_ = this;
    return (
      <div>
      <Container fluid>
        <Row
          style={{
            marginTop:10,
          }}>
          <Col
          xs = {3}
          style={{
            backgroundColor:"#eeeeff"
          }}>
            <div
            style={{
              marginTop:20,
              marginLeft:20,
            }}>
              {
                this_.state.arg.documentInfos.map(info=>
                  <div>
                  <Row><div 
                    style={{
                      cursor:"pointer",
                      userSelect:"none",
                      MozUserSelect:"none",
                      WebkitUserSelect:"none",
                      msUserSelect:"none"
                    }}
                    onClick={() => this_.setIndex(info.firstIndex)}
                  >
                    {
                      this_.state.index === info.firstIndex &&
                      info.contents.length === 1
                      ?
                      <div><strong>{info.title}</strong></div>
                      :
                      <div>{info.title}</div>
                    }
                  </div></Row>
                  {
                    info.contents.length > 1 &&
                    this_.state.index >= info.firstIndex &&
                    this_.state.index < info.firstIndex + info.contents.length
                    ?
                      <div>
                      {
                        info.contents.map(content=>
                          <Row><div 
                            style={{
                              cursor:"pointer",
                              userSelect:"none",
                              MozUserSelect:"none",
                              WebkitUserSelect:"none",
                              msUserSelect:"none"
                            }}
                            onClick={() => this_.setIndex(content.index)}
                          >
                            {
                              this_.state.index === content.index
                              ?
                              <div><strong>{content.subTitle}</strong></div>
                              :
                              <div>{content.subTitle}</div>
                            }
                          </div></Row>
                        )
                      }
                      </div>
                    :
                      <div></div>
                  }
                  </div>
                )
              }
            </div>
          </Col>
  
          <Col
          xs = {7}
          style={{
            marginLeft:20,
            backgroundColor:"#ffffff"
          }}
          >
            <div
            style={{
              marginTop:20,
              marginLeft:20,
            }}>
              {
                this_.state.arg.documentInfos.map(info=>
                  <div>
                    {
                        this_.state.index === info.firstIndex &&
                        info.contents.length === 1
                        ?
                          <div>{info.contents[0].body}</div>  
                        :
                          info.contents.map(content=>
                          <div>
                            {
                              this_.state.index === content.index
                              ?
                              <div>{content.body}</div>  
                              :
                              <div></div>  
                            }
                          </div>)
                    }
                  </div>)
              }
            </div>
          </Col>
        </Row>
  
      </Container>
      </div>
    );  
  }
}

export default BookPage;
